import { Button } from '@/components/ui/button';
import { FileText, X } from 'lucide-react';
import type { WorkflowDocument } from '@/lib/services/correspondences/workflows/workflow-types';

interface AttachmentsDisplayProps {
  attachments: WorkflowDocument[];
  onRemove: (documentId: number) => void;
}

export function AttachmentsDisplay({
  attachments,
  onRemove
}: AttachmentsDisplayProps) {
  if (attachments.length === 0) return null;

  return (
    <div className="bg-muted/30 shrink-0 border-t px-4 py-2">
      <div className="mx-auto flex max-w-4xl flex-wrap gap-2">
        {attachments.map((attachment) => (
          <div
            key={attachment.id}
            className="bg-background inline-flex items-center gap-2 rounded-md border px-3 py-1.5"
          >
            <FileText className="text-muted-foreground h-4 w-4" />
            <span className="max-w-[150px] truncate text-sm">
              {attachment.originalFilename}
            </span>
            <Button
              variant="ghost"
              size="icon-4xs"
              className="ml-1"
              onClick={() => onRemove(attachment.id)}
            >
              <X className="h-3 w-3" />
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
